import { Props } from '../../native';
import Comment from '../../../sub/comment';
import * as React from 'react';
import { NativeTransparencyButton } from '../../parts/native-transparency-button';
import Description from '../../../sub/description';
import { NativeLogo } from '../../parts/native-logo';
import { NativeTitleWithAnchor } from '../../parts/native-title-with-anchor';
import { getImageSizes, NativeImage } from '../../parts/native-image';
import { NativeTopLeftLabel } from '../../parts/native-top-left-label';

export function GeneralResultAd(props: Props) {
    const { id, adObj, deviceType, grid, accessibilityId, vertical } = props;
    const { native } = adObj;
    const mobile = deviceType === 'mobile';
    const list = !grid && !mobile;

    return (
        <div
            id={id}
            aria-owns={accessibilityId}
            className={`ads__unit ads__unit--native`}
        >
            <Comment
                placement={`GeneralResultAd - ${vertical}`}
                adObj={adObj}
            />
            <div className={'relative ads__unit__img'}>
                <NativeImage
                    aspectClass={
                        'ads__unit__img__ratio img-format img-format--centered img-format--ratio3by2'
                    }
                    imageClass={'img-format__img'}
                    imageSizes={getImageSizes(list ? 'list' : 'grid', 'car')}
                    native={native}
                />
                <NativeTopLeftLabel radiusClass={'rounded-br-8 rounded-tl-8'} />
            </div>
            <div className={'ads__unit__content font-normal'}>
                <div
                    className={`flex flex-row justify-between text-12 items-center`}
                >
                    <div
                        className={`text-14 text-gray-500 flex ${
                            list ? 'flex-row mb-4' : 'flex-col'
                        } gap-8`}
                    >
                        {native.sponsoredBy}
                    </div>
                </div>
                <div className={'pb-48 flex flex-row items-end gap-4'}>
                    <div className={`flex flex-col`}>
                        <NativeTitleWithAnchor
                            className={'ads__unit__content__title font-bold'}
                            native={native}
                            accessibilityId={accessibilityId}
                        />
                        <Description native={native} className="text-12" />
                    </div>
                    <div className={'absolute bottom-8 right-8'}>
                        <NativeLogo native={native} />
                    </div>
                </div>
            </div>
            <NativeTransparencyButton
                adObj={adObj}
                className={!list ? '' : 'top-8 right-8'}
            />
        </div>
    );
}
